/* src/app/shared/components/loader/loader.component.scss */
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 2000;
  cursor: pointer;
}
.overlay .loader,
.overlay .loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.overlay .loader {
  margin: auto;
  font-size: 8px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(147, 200, 71, 0.5);
  border-right: 1.1em solid rgba(147, 200, 71, 0.5);
  border-bottom: 1.1em solid rgba(147, 200, 71, 0.5);
  border-left: 1.1em solid #FFFFFF;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
/*# sourceMappingURL=loader.component.css.map */
